import {Column} from "./index.tsx";


export function exportToCSV(data: any[], columns: Column[]) {
    const header = columns.map(c => c.label).join(";")

    const rows = data.map(row => columns.map((column: Column) => {
        const isSynthetic = column.synthetic

        if (isSynthetic && column.export !== undefined) {
            return column.export(row)
        }

        return row[column.key]
    }));

    return header+"\n"+rows.map(r => r.join(";")).join("\n");
}

/*
 {columns.map((column, i) => {
                        const isSynthetic = column.synthetic

                        return <div style={{width: columnWidths[i], padding: "7px 12px"}}
                                    key={column.key + index}>
                            {isSynthetic ? column.render(data[index]) : data[index][column.key]}
                        </div>
                    }
                )}
 */